import { useQuery, useMutation, useQueryClient } from "react-query";
import { getLookupsOATypes, getOAType, getOATypes, saveOAType, deleteOAType } from "@/api/Maintainers/OA/oa-type-api";

export const key = "oa-type-oa";

export function useOATypeLookups() {
	return useQuery([key, "lookups"], () => getLookupsOATypes());
}

export function useOATypes(filters) {
	return useQuery([key, "list", filters], () => getOATypes(filters));
}

export function useOAType(filters, id_element, enabled) {
	return useQuery([key, "detail", filters, id_element], () => getOAType(filters, id_element), {
		enabled: enabled,
		keepPreviousData: true,
	});
}

export function useSaveOAType() {
	const queryClient = useQueryClient();

	return useMutation(saveOAType, {
		onSuccess: (response) => {
			const filters = response.filters;
			const list = response.data;
			const detail = response.detail;

			queryClient.setQueryData([key, "detail", filters, detail.id], detail);
			queryClient.setQueryData([key, "list", filters], list);
		},
	});
}

export function useDeleteOAType() {
	const queryClient = useQueryClient();

	return useMutation(deleteOAType, {
		onSuccess: (response) => {
			const filters = response.filters;
			const list = response.data;

			queryClient.setQueryData([key, "list", filters], list);
		},
	});
}
